var _namedview, _namedview2, _g, _g2, _g3, _g4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSleeveTemplate = function SvgSleeveTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "198.0mm",
    height: "99.5mm",
    viewBox: "-15.0 -5.3 198.0 99.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _namedview2 || (_namedview2 = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -0.30000001,
    x2: 55,
    y1: 4.6999998,
    y2: 4.6999998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 51,
    y1: 4.6999998,
    y2: 3.7,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 51,
    y1: 4.6999998,
    y2: 5.6999998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.30000001,
    x2: 3.7,
    y1: 4.6999998,
    y2: 3.7,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.30000001,
    x2: 3.7,
    y1: 4.6999998,
    y2: 5.6999998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 27.437468,
    y: 10.87812,
    fill: "#000",
    fontSize: "5.64444447px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 89,
    y1: 4.6999998,
    y2: 4.6999998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 85,
    y1: 4.6999998,
    y2: 3.7,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 85,
    y1: 4.6999998,
    y2: 5.6999998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 59,
    y1: 4.6999998,
    y2: 3.7,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 59,
    y1: 4.6999998,
    y2: 5.6999998,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 71.882782,
    y: 10.87812,
    fill: "#000",
    fontSize: "5.64444447px",
    textAnchor: "middle"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 168,
    x2: 168,
    y1: -0.30000001,
    y2: 89.199997,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168,
    x2: 167,
    y1: -0.30000001,
    y2: 3.7,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168,
    x2: 169,
    y1: -0.30000001,
    y2: 3.7,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168,
    x2: 167,
    y1: 89.199997,
    y2: 85.199997,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168,
    x2: 169,
    y1: 89.199997,
    y2: 85.199997,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -46.450001,
    y: 174.05833,
    fill: "#000",
    fontSize: "5.64444447px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Height\n        "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 55,
    y1: -0.30000001,
    y2: 89.199997,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 89,
    y1: -0.30000001,
    y2: 89.199997,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    x2: 144,
    y1: -0.30000001,
    y2: 89.199997,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178,
    x2: 178,
    y1: -0.30000001,
    y2: 89.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    x2: 0,
    y1: 5,
    y2: 0,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    x2: 0,
    y1: 84,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 89,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    x2: -10,
    y1: 5,
    y2: 84,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.30000001,
    x2: 55,
    y1: -0.30000001,
    y2: -0.30000001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 89,
    y1: -0.30000001,
    y2: -0.30000001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 144,
    y1: -0.30000001,
    y2: -0.30000001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    x2: 178,
    y1: -0.30000001,
    y2: -0.30000001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.30000001,
    x2: 55,
    y1: 89.199997,
    y2: 89.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    x2: 89,
    y1: 89.199997,
    y2: 89.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 144,
    y1: 89.199997,
    y2: 89.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    x2: 178,
    y1: 89.199997,
    y2: 89.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    x2: -10,
    y1: 84,
    y2: 44.5,
    stroke: "#000",
    strokeDasharray: "1010,2,5",
    strokeWidth: 0.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSleeveTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sleeve-template.5b4dc9be.svg";
export { ForwardRef as ReactComponent };